<template>
  <transition name="van-slide-right">
    <div v-show="visible">
      <NavBar/>
      <van-form @submit="onSubmit">
        <div class="head">
          <van-row gutter="20">
            <van-col span="12">
              <van-field name="paymentType" label-width="0">
                <template #input>
                  <van-radio-group v-model="keepAccounts.paymentType" direction="horizontal"
                                   @change="paymentTypeChange">
                    <van-radio name="0" shape="square">收入</van-radio>
                    <van-radio name="1" shape="square">支出</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </van-col>
            <van-col span="12" style="padding-right: 10px">
              <van-field
                  readonly
                  clickable
                  name="keepTimeDay"
                  :value="title"
                  placeholder="点击选择时间"
                  @click="dateSelectShow = true"
                  :rules="[
                           { required: true, message: '请选择时间' }]"
              />
              <van-calendar v-model="dateSelectShow" @confirm="dateSelect" :min-date="new Date(2000,0,1)"
                            :max-date="new Date(2030,0,1)"/>
            </van-col>
          </van-row>
          <van-row gutter="20">
            <van-col span="24" style="padding: 10px">
              <van-field v-model="keepAccounts.money" label="￥:" placeholder="0.00" label-width="2em"
                         class="amount-class" type="number" name="money"
                         :rules="[
                           { required: true, message: '请输入金额' },
                           { pattern, message: '请输入正确内容(小数点后两位)' }]"/>
            </van-col>
          </van-row>
          <div>
            <van-divider content-position="left">{{ paymentTypeName }}</van-divider>
            <div style="margin: 10px;text-align: center">
              <van-field name="feeTypeId" label-width="0"
                         :rules="[
                           { required: true, message: '请选择类型' }]">
                <template #input>
                  <van-radio-group v-model="keepAccounts.feeTypeId" direction="horizontal">
                    <van-radio :name="item.id" v-for="item in keepFeeTypes" :key="item.id" shape="square"
                               style="margin: 10px">{{ item.feeTypeName }}
                    </van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </div>
          </div>
          <van-row gutter="20">
            <van-col span="24" style="padding: 10px">
              <van-field
                  readonly
                  clickable
                  label="业务合同"
                  name="contractName"
                  :value="keepAccounts.contractName"
                  placeholder="请选择业务合同"
                  @click="showPicker = true"/>
              <van-popup v-model="showPicker" round position="bottom">
                <van-picker
                    show-toolbar
                    :columns="contracts"
                    @cancel="showPicker = false"
                    @confirm="onConfirm"
                />
              </van-popup>
            </van-col>
          </van-row>
        </div>
        <van-divider content-position="left">费用单据（选填）</van-divider>
        <div class="upload-class">
          <van-field name="feeArrays">
            <template #input>
              <van-uploader v-model="feeArrays" multiple :max-count="9" accept="image/*" :afterRead="uploadFile"
                            :before-delete="delUploadFile" name="feeArrays"/>
            </template>
          </van-field>
        </div>
        <van-divider content-position="left">发票（选填）</van-divider>
        <div class="upload-class">
          <van-field name="invoiceArrays">
            <template #input>
              <van-uploader v-model="invoiceArrays" multiple :max-count="9" accept="image/*" :afterRead="uploadFile"
                            :before-delete="delUploadFile" name="invoiceArrays"/>
            </template>
          </van-field>
        </div>
        <van-divider content-position="left">业务佐证（选填）</van-divider>
        <div class="upload-class">
          <van-field name="epiArrays">
            <template #input>
              <van-uploader v-model="epiArrays" multiple :max-count="9" accept="image/*" :afterRead="uploadFile"
                            :before-delete="delUploadFile" name="epiArrays"/>
            </template>
          </van-field>
        </div>
        <div style="padding:10px 10px 20px 10px;text-align: center">
          <van-button type="info" block round native-type="submit">提交</van-button>
        </div>
      </van-form>


      <!--    <van-calendar v-model="dateSelectShow" :show-confirm="false" @confirm="dateSelect" :min-date="new Date(2020,1,1)"-->
      <!--                  :max-date="new Date(2030,1,1)"/>-->
    </div>
  </transition>
</template>

<script>
import NavBar from "@/components/NavBar";
import cos from "@/utils/objectQCos"
import {getKeepContractList, getKeepFeeTypeList, getTempSecretKey} from "@/api/comm/comm";
import {getDateNumber} from "@/utils/dateUtils";
import {getUUID} from "@/utils/UUIDUtils";
import {addKeepAccounts} from "@/api/cost/cost";
import VantMessage from "@/utils/vantMessageUtils";


export default {
  name: "addCost",
  data() {
    return {
      visible: false,
      pattern: /^([0-9]|[1-9]\d+)(\.\d{2})?$/,
      feeArrays: [],
      invoiceArrays: [],
      epiArrays: [],
      feeArray: [],
      invoiceArray: [],
      epiArray: [],
      paymentTypeName: '支出类型',
      fileSize: true,
      costReceiptsShow: true,
      keepFeeTypes: [],
      contracts: [],
      keepAccounts: {
        paymentType: Number,
        feeTypeId: Number,
        money: '',
        contractId: Number,
        contractName: '',
        keepTimeDay: ''
      },
      amount: '0',
      numberKeyboardShow: false,
      dateSelectShow: false,
      direction: 'down',
      title: '',
      showPicker: false,
    };
  },
  components: {
    NavBar,
  },
  methods: {
    paymentTypeChange(name) {
      this.paymentTypeName = name === "1" ? "支出类型" : "收入类型";
    },
    async onSubmit(values) {
      values.contractId = this.keepAccounts.contractId
      delete values.feeArrays;
      delete values.invoiceArrays;
      delete values.epiArrays;
      values.feeArray = this.feeArray;
      values.invoiceArray = this.invoiceArray;
      values.epiArray = this.epiArray;
      const loading = VantMessage.loadingMsg("提交中")
      let res = await addKeepAccounts(values);
      loading.clear();
      if (res) {
        VantMessage.successMsg("添加成功")
        let this_ = this;
        setTimeout(() => {
          this_.$router.replace("/home");
        }, 1000);
      } else {
        VantMessage.errorMsg("添加失败，请稍后再试")
      }
    },
    onConfirm(value) {
      this.keepAccounts.contractId = value.id;
      this.keepAccounts.contractName = value.text;
      this.showPicker = false;
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    dateSelect(value) {
      this.keepAccounts.keepTimeDay = this.formatDate(value);
      this.title = this.keepAccounts.keepTimeDay
      this.dateSelectShow = false;
    },
    //判断图片
    isOverSize(file) {
      if (file.size > 5242880) {
        this.$toast("请上传小于5M的图片")
        this.fileSize = false;
        return this.fileSize;
      }
      this.fileSize = true;
    },
    //上传图片
    async uploadFile(file, detail) {
      file.status = 'uploading';
      file.message = '上传中...';
      let fileName = file.file.name;
      let type = fileName.substring(fileName.lastIndexOf("."));//.tx
      file.name = getDateNumber() + getUUID() + type;
      let res = await getTempSecretKey(null);
      let this_ = this;
      cos.putObject(res, file, (error, data) => {
        if (error) {
          file.status = 'failed';
          file.message = '上传失败';
        } else {
          file.status = 'done ';
          file.message = '上传成功';
          switch (detail.name) {
            case 'feeArrays':
              this_.feeArrays[detail.index].status = 'done';
              this_.feeArray.push("https://" + data.Location)
              break;
            case 'invoiceArrays':
              this_.invoiceArrays[detail.index].status = 'done';
              this_.invoiceArray.push("https://" + data.Location)
              break;
            case 'epiArrays':
              this_.epiArrays[detail.index].status = 'done';
              this_.epiArray.push("https://" + data.Location);
              // this_.epiArray[detail.index].imgUrl = "https://" + data.Location;
              break;
            default:
              this.$toast("系统异常，请联系客服")
              break;
          }
        }
      })
    },
    //删除图片
    async delUploadFile(file, detail) {
      let res = await getTempSecretKey(null);
      if (res) {
        let this_ = this;
        let fileImg = '';
        switch (detail.name) {
          case 'feeArrays':
            fileImg = this_.feeArray[detail.index]
            break;
          case 'invoiceArrays':
            fileImg = this_.invoiceArray[detail.index]
            break;
          case 'epiArrays':
            fileImg = this_.epiArray[detail.index]
            break;
          default:
            break;
        }
        const arr = []
        fileImg.split('/').forEach((item, index) => {
          if (index !== 0 && index !== 1 && index !== 2) {
            arr.push(item)
          }
        })
        fileImg = arr.join('/');

        await cos.delObject(res, fileImg, (error, data) => {
          if (error) {
            console.log(error)
          } else {
            switch (detail.name) {
              case 'feeArrays':
                this_.feeArrays.splice(detail.index, 1)
                this_.feeArray.splice(detail.index, 1)
                break;
              case 'invoiceArrays':
                this_.invoiceArrays.splice(detail.index, 1)
                this_.invoiceArray.splice(detail.index, 1)
                break;
              case 'epiArrays':
                this_.epiArrays.splice(detail.index, 1)
                this_.epiArray.splice(detail.index, 1)
                break;
              default:
                break;
            }
          }
        })
      }
    },
    //查询收支出类型标签
    async getKeepFeeTypeList() {
      let res = await getKeepFeeTypeList(null);
      if (res.length > 0) {
        this.keepFeeTypes = res;
      }
    },
    //查询合同
    async getKeepContractList() {
      let res = await getKeepContractList(null);
      if (res.length > 0) {
        for (let i = 0; i < res.length; i++) {
          this.contracts.push({
            text: res[i].contractName,
            id: res[i].id
          })
        }
      }
    }
  },
  mounted() {
    this.visible = true;
    this.getKeepFeeTypeList();
    this.getKeepContractList();
    document.title = this.$route.meta.title
  }
}
</script>

<style scoped>
.head {
  /*margin-top: 10px;*/
  padding: 10px 0;
  /*text-align: center;*/
  width: 100vw;
  /*height: 250px;*/
  border-radius: 0 0 20px 20px;
  background-color: #FFF;
  /*box-shadow: 0px 15px 10px -15px;*/
}

.data-class {
  width: 200px;
  float: right;
  line-height: 20px;
  margin-right: 20px;
  margin-bottom: 10px;
  /*margin-top: 30px;*/
  /*background-color: #cd372e;*/
  font-size: 18px;
  /*color: white;*/
  border-radius: 10px
}

.upload-class {
  border-radius: 10px;
  background-color: #FFFFFF;
}

.tag-class {
  margin: 5px;
}

.amount-class {
  font-size: 25px;
  background-color: #f2f2f2;
  line-height: 25px;
  border-radius: 5px;
}
</style>
